import React, { Fragment, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AppRoutes from "./router";
import { usePageTracking } from "hooks/useTrackPageView";
import * as Sentry from "@sentry/react";
import ReactGA from "react-ga4";
import FallbackUI from "components/ErrorBoundary";

const App: React.FC = () => {
  const PageTracker = () => {
    const location = useLocation();
    usePageTracking();

    useEffect(() => {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
      // throw new Error('This is a test error for Sentry');
    }, [location]);

    return null;
  };

  return (
    <Fragment>
      <Sentry.ErrorBoundary
        fallback={({ error, componentStack }) => {
          // Type guard to convert unknown to Error | null
          const safeError = error instanceof Error ? error : null;
          return (
            <FallbackUI error={safeError} componentStack={componentStack} />
          );
        }}
        // onError={(error, componentStack, eventId) => {
        //   console.error(
        //     "ErrorBoundary caught an error:",
        //     error,
        //     componentStack,
        //     eventId
        //   );
        // }}
      >
        <PageTracker />
        <div className="flex flex-col min-h-screen">
          <div className="flex-grow">
            <AppRoutes />
          </div>
        </div>
      </Sentry.ErrorBoundary>
    </Fragment>
  );
};

export default App;
